import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings
} from '../../../actions/settings';
import Table from './EmployeeTable'
import { Col, Grid, Row } from "react-bootstrap";
import { employees } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import { TableHeader } from '../../orders/OrdersTable';
import { Form } from 'react-bootstrap/lib/Navbar';

let Employee = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            employeeToEdit: null
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addEmployee = this._addEmployee.bind(this);
        this._updateEmployee = this._updateEmployee.bind(this);
    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(employees);
    }

    _onAddClick() {
        this.setState({ showAddModal: true });
    }

    _addEmployee(employee) {
        this.props.updateSettings(employees, employee);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            employeeToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(employees);
    }

    _onEditClick(employee) {
        this.setState({ employeeToEdit: employee, showUpdateModal: true })
    }

    _updateEmployee(employee) {
        this.props.updateSettings(employees, employee, employee.Id);
    }

    render() {
        const { employees: { data, fetching } } = this.props;
        const { showAddModal, showUpdateModal, employeeToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: employeeToEdit ? employeeToEdit : {
                Name: undefined,
                Login: undefined,
                Password: undefined,
                Role: undefined,
                IsActive: true,
                Location: undefined,
                Phone: undefined
            },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addEmployee : this._updateEmployee
        };
        
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        const admins = data ? data.filter(e => e.Role == permissions.ADMIN) : undefined;
        const operator = data ? data.filter(e => e.Role == permissions.OPERATOR) : undefined;
        const receptionPoint = data ? data.filter(e => e.Role == permissions.RECEPTION_POINT): undefined;
        const inspector = data ? data.filter(e => e.Role == permissions.INSPECTOR): undefined;

        return (
            <Panel>
                <Panel.Heading >
                    <span>Сотрудники</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='jobs-container'>
                        <Col>
                            <p><b>Администратор</b></p>
                                <Table
                                    fetching={fetching}
                                    employees={admins}
                                    onEdit={this._onEditClick}
                                    isReadOnly={isReadOnly} />
                            <p><b>Оператор</b></p>
                            <Table
                                fetching={fetching}
                                employees={operator}
                                onEdit={this._onEditClick}
                                isReadOnly={isReadOnly} />
                            
                            <p><b>Пункт приема</b></p>
                            <Table
                                fetching={fetching}
                                employees={receptionPoint}
                                onEdit={this._onEditClick}
                                isReadOnly={isReadOnly}
                                isReceptionPoint={true}
                                useReceptionPointFilter />
                               
                            <p><b>Приемщик</b></p>
                            <Table
                                fetching={fetching}
                                employees={inspector}
                                onEdit={this._onEditClick}
                                isReadOnly={isReadOnly} />
                        </Col>
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Employee = connect(state => ({
    employees: state.application.get('settings')[employees]
}), { getSettings, updateSettings, clearUpdateSettings })(Employee);

export default Employee;



// WEBPACK FOOTER //
// ./src/components/settings/employee/Employee.jsx